/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ActionItemDto = {
    SetAvailability: 'SetAvailability',
    View: 'View',
    Edit: 'Edit',
    Copy: 'Copy',
    Delete: 'Delete',
    Execute: 'Execute',
    Review: 'Review',
    SendActivation: 'SendActivation'
} as const;
export type ActionItemDto = typeof ActionItemDto[keyof typeof ActionItemDto];


export function ActionItemDtoFromJSON(json: any): ActionItemDto {
    return ActionItemDtoFromJSONTyped(json, false);
}

export function ActionItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionItemDto {
    return json as ActionItemDto;
}

export function ActionItemDtoToJSON(value?: ActionItemDto | null): any {
    return value as any;
}

/**
 * Check if a given object implements the ActionItemDto interface.
 */
 export function instanceOfActionItemDto(value: any): value is ActionItemDto {
    return Object.values(ActionItemDto).includes(value)
}

